import React from "react";
import CampaignService from "../../service/CampaignService";
import { useNavigate } from "react-router-dom";

const CancelApplication = ({ kind, customerNo, code, customerInfo }) => {
  const navigate = useNavigate();

  const handleCancel = async () => {
    try {
      const result = await CampaignService.customerCancel(kind, customerNo, code);

      if (result) {
        navigate("/cancelcomplete");
      } else {
        alert("신청 취소에 실패하였습니다.");
      }
    } catch (error) {
      alert("신청 취소에 실패하였습니다.");
    } finally {
    }
  };

  return (
    <div className="sm:min-w-screen md:max-w-[400px] flex flex-col justify-between items-center mx-auto min-h-screen bg-white">
      <div className="flex flex-col items-center mb-20 p-4 mt-[125px]">
        {/* <img src="/assets/img/logo1.png" className="w-[150px] h-[47px] object-cover mb-2" /> */}
        <img src={customerInfo?.로고경로 || ""} className="max-w-[150px] h-[47px] mb-2 object-fill" />
        <p className="text-lg font-bold text-[#6a6a6a] mb-2">{customerInfo?.매체 || ""}</p>
      </div>
      <div className="text-center mb-4 p-4">
        <span className="block text-[22px] font-bold text-black mb-2">{`${customerInfo?.고객명 || ""} 고객님!`}</span>
        <span className="block text-sm font-bold text-[#5f5f5f]">홈쇼핑 프로모션에 참여해 주셔서 감사합니다.</span>
      </div>
      <div className="flex-grow"></div> {/* 이 부분을 추가하여 위쪽과 아래쪽 요소 사이에 공간을 만듭니다. */}
      <div className="text-center mb-4 p-4">
        <span className="block text-sm font-bold text-[#3e9ff9]">
          상단의 <span className=" text-sm font-bold text-black">채널추가</span>
          <span className=" text-sm font-bold text-[#3e9ff9]">를 클릭해 주시면</span>
        </span>
        <span className="block text-sm font-bold text-[#3e9ff9]">더 좋은 상품으로 찾아뵐께요.</span>
      </div>
      <div className="flex justify-center items-center w-full h-14 cursor-pointer  rounded-0 bg-[#3e9ff9]" onClick={handleCancel}>
        <span className="text-[16px] font-bold text-white">신청 취소</span>
      </div>
      {/* <div className="mb-4"></div>  이 부분을 추가하여 페이지 하단에 일정한 간격을 만듭니다. */}
    </div>
  );
};

export default CancelApplication;
